import PropTypes from "prop-types";

import ButtonNew from "components/atoms/ButtonNew/index";
import { FaCheck } from "components/atoms/Icon/fa/FaCheck";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import FormCountries from "components/molecules/FormCountries";
import AccountingAuditing from "components/organisms/AccountingAuditing";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";

const AccountingService = ({ item }) => {
  return (
    <div className="flex h-full flex-col items-center">
      <div className="mb-4 inline-flex h-20 w-20 items-center justify-center rounded-xl bg-white">
        <Img
          src={item.image}
          width={48}
          height={48}
          alt={item.name}
          wrapper={{ className: "block" }}
        />
      </div>
      <p
        className="text-center text-lg text-white"
        dangerouslySetInnerHTML={{ __html: item.name }}
      />
    </div>
  );
};

const TaxServiceCard = ({ item }) => {
  return (
    <div className="lg:shadow-bbc flex h-full flex-col justify-between overflow-hidden rounded-3xl border bg-white px-8 pt-9 shadow-none lg:border-0 lg:px-0">
      <div className="flex justify-center">
        <div className="mb-6 inline-flex h-20 w-20 items-center justify-center rounded-3xl bg-bbc-brand-100">
          <Img src={item.image} width={38} height={48} alt={item.name} />
        </div>
      </div>
      <p
        className="mb-4 flex-grow text-center lg:px-3"
        dangerouslySetInnerHTML={{ __html: item.content }}
      />

      <div className="border-t py-4 lg:px-3">
        <p className="text-center text-5xl font-semibold text-bbc-yellow-500">
          {item.price}
        </p>
      </div>
    </div>
  );
};

const DocumentCard = ({ item }) => {
  return (
    <div className="lg:shadow-bbc flex h-full flex-col justify-between overflow-hidden rounded-3xl border bg-white pt-9 shadow-none lg:border-0">
      <div className="flex justify-center">
        <div className="mb-6 inline-flex h-20 w-20 items-center justify-center rounded-3xl bg-bbc-brand-100">
          <Img src={item.image} width={38} height={48} alt={item.name} />
        </div>
      </div>
      <div className="flex-grow border-t px-7 pb-4 pt-2">
        <p
          className="text-center"
          dangerouslySetInnerHTML={{ __html: item.name }}
        />
      </div>
    </div>
  );
};

const AccountingAndAuditing = ({ data }) => {
  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-min-h-635"
          title="Accounting,<br/>Auditing & Tax Filing <br/>in Hong Kong"
          bgColor="bg-bbc-gradient-service"
          breadcrumbs={[
            { title: "Home", uri: "/" },
            { title: "Accounting, Auditing & Tax Filing", uri: "#" },
          ]}
          leftClassName=" lg:col-6"
          rightClassName=" lg:col-6"
          rightContent={
            <Img
              src="/assets/images/hk/accounting-auditing/banner-accountinga-and-auditing.png"
              width={553}
              height={488}
              alt="Hong Kong accounting service"
              className="h-full w-full"
              wrapper={{
                className: "bbc-banner-image-country xl:top-24 pb-10 lg:pb-0",
              }}
              priority={true}
            />
          }
        />
      </section>
      <section>
        <div className="container">
          <div className="row lg:flex-row-reverse">
            <div className="col-12 flex justify-center lg:col-5">
              <Img
                src="/assets/images/hk/accounting-auditing/requirements-hk-accounting.png"
                width={445}
                height={456}
                alt="accounting requirements in Hong Kong"
              />
            </div>
            <div className="col-12 lg:col-7 lg:pr-10">
              <p className="pb-4">
                Under Hong Kong Inland Revenue Ordinance and Companies
                Ordinance, Hong Kong-registered companies are required to
                prepare and maintain financial records and hire a local
                qualified accounting firm to perform audit tasks on financial
                statements.
              </p>
              <p className="pb-4">
                Special notes for Hong Kong Company accounting and auditing:
              </p>
              <ul className="leading-bbc-26">
                <li className="relative mb-4">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Hong Kong company must maintain accounting records for at
                    least 7 years since the end of the financial year.
                  </span>
                </li>
                <li className="relative mb-4">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    All Hong Kong companies must carry out an audit on their
                    annual financial statements, except for dormant companies.
                  </span>
                </li>
              </ul>
              <p>
                BBCIncorp Limited offers qualified Hong Kong accounting services
                for your business! Our team of experienced Certified Public
                Accountants will help you relieve from reporting burden and have
                more time to concentrate on your business. Effective
                communication and seamless integration will make us your great
                companion.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-bbc-gradient-2">
        <div className="container relative py-10 lg:py-20">
          <Title className="title-h2 mb-10 text-center font-semibold text-bbc-white lg:mb-10">
            Hong Kong Accounting Services with BBCIncorp
          </Title>
          <div className=" col-10 m-auto">
            <div className="row gap-y-16">
              <div className="col-12 md:col-6 lg:col-3">
                <AccountingService
                  item={{
                    image:
                      "/assets/images/hk/accounting-auditing/cloud_accounting-hk-accounting.svg",
                    name: "Cloud accounting",
                  }}
                />
              </div>
              <div className="col-12 flex flex-col items-center md:col-6 lg:col-3">
                <AccountingService
                  item={{
                    image:
                      "/assets/images/hk/accounting-auditing/affortable-hk-accounting.svg",
                    name: "Affordable &<br /> transparent pricing",
                  }}
                />
              </div>
              <div className="col-12 flex flex-col items-center md:col-6 lg:col-3">
                <AccountingService
                  item={{
                    image:
                      "/assets/images/hk/accounting-auditing/communication-hk-accounting.svg",
                    name: "Effective <br /> communication",
                  }}
                />
              </div>
              <div className="col-12 flex flex-col items-center md:col-6 lg:col-3">
                <AccountingService
                  item={{
                    image:
                      "/assets/images/hk/accounting-auditing/certificated-hk-accounting.svg",
                    name: "CPA certified <br /> experts",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <AccountingAuditing services={data.serviceFees} />
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <Title
              text="Tax Filing Services"
              className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10"
            />
            <p className="mb-10">
              Hong Kong tax year or year of assessment begins from 1st April to
              31st March in the next year. A company is liable for its first tax
              return filing around 18 months from the incorporation date and
              every financial year end subsequently. Business owners should be
              aware of tax filing obligations to avoid heavy penalties by Hong
              Kong Tax Authority.
              <br />
              <br />
              Our experienced accountants will cover your back with tax planning
              and consultation. We also help you with offshore tax claim
              applications for income derived outside Hong Kong.
              <br />
              <br />
              Below is the pricing for our corporate tax filing service.
            </p>
          </div>
          <div className="row mb-8 justify-center gap-y-8 md:mb-10">
            <div className="col-12 md:col-5 lg:col-4 xl:col-3">
              <TaxServiceCard
                item={{
                  name: "tax computation",
                  image:
                    "/assets/images/hk/accounting-auditing/tax_computation-hk-accounting.svg",
                  content:
                    "Filing Profits Tax Return and tax computation with supporting schedules",
                  price: "$100",
                }}
              />
            </div>
            <div className="col-12 md:col-5 lg:col-4 xl:col-3">
              <TaxServiceCard
                item={{
                  name: "Filing",
                  image:
                    "/assets/images/hk/accounting-auditing/filling-hk-accounting.svg",
                  content: "Filing Employer’s Return<br />(NIL)",
                  price: "$100",
                }}
              />
            </div>
          </div>
          <div className="flex justify-center">
            <ButtonNew as="a" useRouter href="/contact-us">
              Start Experiencing Our Service
            </ButtonNew>
          </div>
        </div>
      </section>
      <section className="relative bg-bbc-gradient-liner">
        <Img
          src="/assets/images/hk/accounting-auditing/bg_verblue-hk-accounting.png"
          width={375}
          height={928}
          className="absolute left-0 top-0 h-full w-full md:hidden"
          alt="bg blue"
        />
        <Img
          src="/assets/images/hk/accounting-auditing/bg_blue-hk-accounting.png"
          width={1920}
          height={420}
          className="absolute left-0 top-0 hidden h-full w-full md:block"
          alt="bg blue"
        />
        <div className="container relative py-10 lg:py-20">
          <Title
            text="Documents Required"
            className="mb-6 text-center text-3xl font-semibold text-white lg:mb-10 lg:text-bbc-40px"
          />
          <div className="row justify-center gap-8">
            <div className="col-12 px-11  md:px-0 lg:col-3">
              <DocumentCard
                item={{
                  name: "All invoices in the<br/>reporting period",
                  image:
                    "/assets/images/hk/accounting-auditing/invoice-hk-accounting.svg",
                }}
              />
            </div>
            <div className="col-12 px-11  md:px-0 lg:col-3">
              <DocumentCard
                item={{
                  name: "Company bank<br/>statements",
                  image:
                    "/assets/images/hk/accounting-auditing/tax_computation-hk-accounting.svg",
                }}
              />
            </div>
            <div className="col-12 px-11  md:px-0 lg:col-3">
              <DocumentCard
                item={{
                  name: "Company incorporation<br/>documents",
                  image:
                    "/assets/images/hk/accounting-auditing/filling-hk-accounting.svg",
                }}
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <FormCountries
              title="Need more help with your Hong Kong accounting plan?"
              descriptionClass="mb-6 lg:mb-10 text-center"
              description="Just get in touch with us. We typically respond within 2 hrs."
              nameProps={{ placeholder: "First Name*" }}
              messageProps={{ placeholder: "Your Message*" }}
              country_id={98}
            />
          </div>
        </div>
      </section>
      <div className="mb-10 lg:mb-0">
        <div className="container">
          <div className="m-auto lg:col-10">
            <Faqs data={data.dataFaqs} description=" " />
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountingAndAuditing;

AccountingAndAuditing.propTypes = {
  data: PropTypes.object,
};

AccountingAndAuditing.defaultProps = {
  data: {},
};
